const countries = [
  { code: "au", label: "Australia" },
  { code: "br", label: "Brazil" },
  { code: "ca", label: "Canada" },
  { code: "ch", label: "Switzerland" },
  { code: "cn", label: "China" },
  { code: "eg", label: "Egypt" },
  { code: "fr", label: "France" },
  { code: "de", label: "Germany" },
  { code: "gr", label: "Greece" },
  { code: "hk", label: "Hong Kong" },
  { code: "in", label: "India" },
  { code: "ie", label: "Ireland" },
  { code: "it", label: "Italy" },
  { code: "jp", label: "Japan" },
  { code: "nl", label: "Netherlands" },
  { code: "no", label: "Norway" },
  { code: "ph", label: "Philippines" },
  { code: "pt", label: "Portugal" },
  { code: "ro", label: "Romania" },
  { code: "ru", label: "Russia" },
  { code: "sg", label: "Singapore" },
  { code: "es", label: "Spain" },
  { code: "se", label: "Sweden" },
  { code: "tw", label: "Taiwan" },
  { code: "ua", label: "Ukraine" },
  { code: "gb", label: "United Kingdom" },
  { code: "us", label: "United States" },
];

export default countries;